import React from 'react';
import Format from '../../utils/Formatter';

class OrdersList extends React.Component {

    componentDidMount() {
        $('.cpfField').mask('000.000.000-00');
        this.timer = setInterval(() => this.props.onRefresh(), 30000);
    }

    componentDidUpdate() {
        $('.cpfField').mask('000.000.000-00');
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const selectedOrder = this.props.selectedOrder;
        const lastOrder = this.props.lastOrder;
        const orders = this.props.orders.filter(o => o.cpf.startsWith(this.props.cpf));
        const noOrderText = this.props.noOrderText;
        const badgeType = this.props.badgeType;
        const badgeGlyph = this.props.badgeGlyph;
        const title = this.props.title;
        const onRefresh = this.props.onRefresh || function () {};
        const onClickBadge = this.props.onClickBadge || function () {};
        const onSelectOrder = this.props.onSelectOrder || function () {};

        const isActive = (id) => selectedOrder && id === selectedOrder.id;
        const onClickBadgeWrapper = (e, cartId) => {
            e.stopPropagation();
            onClickBadge(cartId);
        };
        const onSelectOrderWrapper = (orderId) => {
            if (!isActive(orderId)) {
                onSelectOrder(orderId);
            }
        };

        const ordersItems = orders
            .sort((o1, o2) => moment(o2.data_associado).diff(moment(o1.data_associado)))
            .map(o => (
            <button className={"list-group-item" + (isActive(o.id) ? " active" : "")} key={o.id} onClick={() => onSelectOrderWrapper(o.id)}>
                <span className="badge pull-left">{"#" + o.id}</span>
                <strong className="cpfField" style={{"paddingLeft": "5%"}}>{o.cpf}</strong>
                <span className={"badge " + badgeType} onClick={(e) => onClickBadgeWrapper(e, o.id)}>
                    <i className={badgeGlyph} />
                </span>
                <span className="badge bg-info">{Format.dateTime(o.data_associado)}</span>
            </button>
        ));
        const noOrdersMessage = <span>{noOrderText}</span>;

        return (
            <div className="panel panel-color panel-info js-panel-resp">
                <div className="panel-heading">
                    <button type="button" className="close" onClick={onRefresh}>
                        <span className="glyphicon glyphicon-refresh" />
                    </button>
                    <h3 className="panel-title">{title}</h3>
                </div>
                <div className="panel-body">
                    <div className={"list-group " + (!lastOrder ? "js-panel-body-wo-footer" : "js-panel-body-w-big-footer")}>
                        {orders.length !== 0 ? ordersItems : noOrdersMessage}
                    </div>
                </div>
                {lastOrder &&
                    <div className="panel-footer">
                        <div className="list-group-item">
                            <span className="badge pull-left">{"#" + lastOrder.id}</span>
                            <strong className="cpfField" style={{"paddingLeft": "5%"}}>{lastOrder.cpf}</strong>
                            <span className="badge bg-info" onClick={this.props.onPrintLastOrder}>
                                <i className="glyphicon glyphicon-print" />
                            </span>
                            <span className="badge bg-info">{Format.dateTime(lastOrder.data_associado)}</span>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default OrdersList;



// WEBPACK FOOTER //
// src/views/controls/OrdersList.jsx